// extracted by mini-css-extract-plugin
export default {"skeleton":"ZlV086","skeletonGroup":"xMa_TB"};